import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as formActions } from 'react-redux-form';
import depositActions from 'actions/depositActions';
import { welcomeCard as WelcomeCard } from 'components/welcomeCard/welcomeCard';
import modalCancelActions from 'actions/modalCancelActions';

import { DesignYourDeposit } from './designYourDeposit.jsx';

const DesignYourDepositContainer = props => {
    return (
        <>
            <DesignYourDeposit {...props} /> <WelcomeCard />
        </>
    );
};

const mapStateToProps = state => {
    return {
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        products: state.products,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        formActions: bindActionCreators(formActions, dispatch),
        depositActions: bindActionCreators(depositActions, dispatch),
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
    };
};

export const DesignYourDepositComponent = connect(mapStateToProps, mapDispatchToProps)(DesignYourDepositContainer);
